import script from "./DashboardEjecutivoView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardEjecutivoView.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardEjecutivoView.vue?vue&type=style&index=0&id=5a8546ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9243d0548d070ce3cb63e50486d60596/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8546ea"]])

export default __exports__